import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import { setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 검색 키워드에 연결된 검색 키워드 아이템 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'순번'} />,
      dataIndex: 'no',
      render: (value, record, index) => index + 1,
    },
    {
      title: <TableColumnTitle title={'검색 키워드 ID'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'검색 키워드'} />,
      dataIndex: 'word',
    },
    {
      title: <TableColumnTitle title={'검색 누적 횟수'} />,
      dataIndex: 'count',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'검색 키워드 생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
